<dw-ui-panel [defaultOpenedPanel]="info" [triggers]="triggers()">
  <dw-grid-detail-navigation
    header-actions
    [context]="[GoliathDocumentEntityNames.StockDocInventory.shortName]"
  >
  </dw-grid-detail-navigation>
  <dw-grid-tabs>
    <div class="tabs">
      <ul
        ngbNav
        #nav="ngbNav"
        (navChange)="onTabChanged($event.nextId)"
        class="nav-underline nav-tabs d-flex border-0 me-md-auto"
      >
        <li [ngbNavItem]="'general'">
          <a ngbNavLink appDwNavLink>
            <i class="digi-out-alert-info me-2 text-primary"></i>{{ '::General' | abpLocalization }}
          </a>
          <ng-template ngbNavContent>
            <div ngbScrollSpy #spy="ngbScrollSpy" #scrollSpy>
              <div class="mt-2 container-panel">
                <form
                  id="generalForm"
                  [formGroup]="form"
                  [DwKeyboardShortcut]="shortcut.controlS"
                  (shortcutAction)="save()"
                >
                  <div class="card-group mb-2 mt-2 header">
                    <div class="card p-2 border">
                      <div>
                        <label for="companySiteId" class="form-label text-primary" dwInputRequired>
                          {{ '::Site' | abpLocalization }}
                        </label>
                        <ng-select
                          class="form-control"
                          id="companySiteId"
                          bindLabel="code"
                          bindValue="id"
                          formControlName="companySiteId"
                          [loading]="companySiteStore.loading()"
                          [items]="companySiteStore.entities()"
                          [readonly]="entityLinesNotEmpty()"
                        >
                        </ng-select>
                      </div>
                      <div>
                        <label for="warehouseId" class="form-label text-primary">
                          {{ 'Doc::StockDoc:Warehouse' | abpLocalization }}
                        </label>
                        <ng-select
                          class="form-control"
                          id="warehouseId"
                          bindLabel="code"
                          bindValue="id"
                          formControlName="warehouseId"
                          [items]="warehouses"
                          [readonly]="entityLinesNotEmpty()"
                        >
                          <ng-template ng-label-tmp let-item="item">
                            @if (item != null) {
                              {{ item.code }} - {{ item.name }}
                            }
                          </ng-template>
                          <ng-template
                            ng-option-tmp
                            let-item="item"
                            let-index="index"
                            let-search="searchTerm"
                          >
                            <span [title]="item.code + ' - ' + item.name"
                              >{{ item.code }} - {{ item.name }}
                            </span>
                          </ng-template>
                        </ng-select>
                      </div>
                    </div>

                    <div class="card p-2 border">
                      <div>
                        <label for="dayBookId" class="form-label text-primary" dwInputRequired>
                          {{ 'Doc::DayBook' | abpLocalization }}
                        </label>
                        <ng-select
                          class="form-control"
                          id="dayBookId"
                          formControlName="dayBookId"
                          bindLabel="name.current"
                          bindValue="id"
                          [items]="dayBooks$ | async"
                        >
                        </ng-select>
                      </div>
                      <div>
                        <label for="number" class="form-label text-primary">
                          {{ '::Number' | abpLocalization }}
                        </label>
                        <input
                          type="text"
                          id="number"
                          class="form-control"
                          readonly
                          [value]="entity?.displayNumber ?? ''"
                        />
                      </div>
                    </div>
                    <div class="card p-2 border">
                      <div>
                        <label for="documentDate" class="form-label text-primary" dwInputRequired>
                          {{ 'Doc::CustomerQuote:DocumentDate' | abpLocalization }}
                        </label>
                        <dw-core-date-picker formControlName="documentDate"></dw-core-date-picker>
                      </div>
                      <div>
                        <label for="currencyCode" class="form-label text-primary">
                          {{ '::Currency' | abpLocalization }}
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          formControlName="currencyCode"
                          [readOnly]="true"
                        />
                      </div>
                    </div>
                    <div class="card p-2 border card-double">
                      <div class="col-md-6 p-0">
                        <label for="salesPersonId" class="form-label text-primary" dwInputRequired>
                          {{ '::Responsible' | abpLocalization }}
                        </label>
                        <ng-select
                          class="form-control"
                          id="salesPersonId"
                          formControlName="salesPersonId"
                          bindValue="id"
                          [loading]="salesPersonStore.loading()"
                          [items]="salesPersonStore.internalSalesPersons()"
                        >
                          <ng-template ng-label-tmp let-item="item">
                            @if (item != null) {
                              @if (item.lastName != null) {
                                {{ item.lastName }} {{ item.firstName ?? '' }}
                              } @else {
                                {{ item.code }}
                              }
                            }
                          </ng-template>
                          <ng-template
                            ng-option-tmp
                            let-item="item"
                            let-index="index"
                            let-search="searchTerm"
                          >
                            <span [title]="item.firstName + ' ' + item.lastName">
                              @if (item != null) {
                                @if (item.lastName != null) {
                                  {{ item.lastName }} {{ item.firstName ?? '' }}
                                } @else {
                                  {{ item.code }}
                                }
                              }
                            </span>
                          </ng-template>
                        </ng-select>
                      </div>
                      <div>
                        <label for="description" class="form-label text-primary">
                          {{ '::Description' | abpLocalization }}
                        </label>
                        <input type="text" class="form-control" formControlName="description" />
                      </div>
                    </div>
                  </div>

                  @if (entity?.id) {
                    <div ngbScrollSpyFragment="products" dwScrollSpyItem [fragment]="'products'">
                      <document-stock-doc-inventory-lines-grid
                        #stockDocLineGrid
                        [stockDoc]="entity"
                        (lineUpdatedEvent)="refreshAfterLineUpdate($event)"
                        (importLineEnded)="refreshEntity()"
                      ></document-stock-doc-inventory-lines-grid>
                    </div>
                  }
                </form>
              </div>
            </div>
          </ng-template>
        </li>

        <li [ngbNavItem]="'classification'" [disabled]="!entity?.id">
          <a ngbNavLink appDwNavLink>
            <i class="digi-out-classifications me-2 text-primary"></i
            >{{ '::Classifications' | abpLocalization }}
          </a>
          <ng-template ngbNavContent>
            <div ngbScrollSpy #spy="ngbScrollSpy" #scrollSpy>
              <document-doc-classifications
                class="d-block"
                [form]="form"
                [docClassificationValues]="docClassificationValues$ | async"
              ></document-doc-classifications>
            </div>
          </ng-template>
        </li>
        <li [ngbNavItem]="'others'">
          <a ngbNavLink appDwNavLink>
            <i class="digi-out-three-points-horizontal-1 me-2 text-primary"></i
            >{{ 'Doc::CustomerQuote:Others' | abpLocalization }}
          </a>
          <ng-template ngbNavContent>
            <div ngbScrollSpy #spy="ngbScrollSpy" #scrollSpy>
              <document-doc-customer-others
                class="d-block"
                [docForm]="form"
                [docRoleInput]="docRole"
              ></document-doc-customer-others>
            </div>
          </ng-template>
        </li>

        <li [ngbNavItem]="'annexes'">
          <a ngbNavLink appDwNavLink (click)="fetchAnnexes()">
            <i class="digi-out-text-file me-2 text-primary position-relative">
              <dw-ui-counter [value]="annexesCount"></dw-ui-counter>
            </i>
            {{ 'Doc::Annexes' | abpLocalization }}
          </a>
          <ng-template ngbNavContent>
            <div ngbScrollSpy #spy="ngbScrollSpy" #scrollSpy>
              <core-annexes-list
                class="d-block"
                [canDownload]="true"
                [canUpload]="true"
                [canDelete]="true"
                [canPreview]="true"
                [canEdit]="true"
                [folderName]="'quote-detail/' + entity?.id"
                [annexes]="annexesAsPromise$ | async"
                (createOrUpdateAnnexes)="createOrUpdateAnnexes($event)"
                (deleteAnnex)="deleteAnnex($event)"
                (deleteAnnexes)="deleteAnnexes($event)"
              ></core-annexes-list>
            </div>
          </ng-template>
        </li>
      </ul>
      @if (entity?.id) {
        <dw-ui-dropdown-menu [dropdownMenu]="actions()"></dw-ui-dropdown-menu>
      }
      <button
        (click)="saveActionBtns()[0].action()"
        class="btn btn-primary"
        type="submit"
        form="generalForm"
        [disabled]="entity?.isStockValidated"
      >
        {{ buttonLabel() | abpLocalization }}
      </button>
    </div>

    <div [ngbNavOutlet]="nav" class="tab-content"></div>
  </dw-grid-tabs>

  <div side-panel-content>
    <dw-ui-side-panel #info [contentTemplate]="bodyTotal">
      <ng-template #bodyTotal>
        @if (entity?.isStockValidated) {
          <div class="aside-tags">
            <div>
              <span class="ui-tag badge rounded-pill bg-success">
                {{ '::Validated' | abpLocalization }}
              </span>
            </div>
          </div>
        }
        @if (entity != null) {
          <div class="aside-body">
            <div class="audit-container mb-3">
              <core-informations-audited-entity [auditedEntity]="entity">
              </core-informations-audited-entity>
            </div>
          </div>
        }
        <label for="note" class="form-label text-primary mt-3">{{
          'GoliathCore::Note' | abpLocalization
        }}</label>
        @if (entity != null) {
          <textarea
            name="note"
            class="flex-grow-1"
            resize="none"
            [(ngModel)]="entity.note"
            (input)="updateNote($event)"
          ></textarea>
        }
      </ng-template>
    </dw-ui-side-panel>
    <dw-ui-side-panel class="side-panel--full" #chatPanel [contentTemplate]="bodyChat">
      <ng-template #bodyChat>
        <dw-core-chat
          [entityId]="entity?.id"
          [entityName]="GoliathDocumentEntityNames.StockDocInventory.shortName"
          [entityReference]="entity?.displayNumber"
        ></dw-core-chat>
      </ng-template>
    </dw-ui-side-panel>
  </div>
</dw-ui-panel>

<ng-template #report let-offcanvas>
  <dw-ui-dialog-box [title]="'Reporting::Report:ReportPdf'" [displayFooter]="false">
    <dw-report-viewer
      [reportName]="docRole"
      [dataId]="entity.id"
      [templateId]="printTemplateId"
      (pdfRequested)="downloadPdfReport()"
    ></dw-report-viewer>
  </dw-ui-dialog-box>
</ng-template>
